const InputField = ({
  label,
  type = "text",
  value,
  name,
  onChange,
  placeholder,
  error,
  clsname,
  inpcls,
  disabled = false,
  readOnly = false,
}) => {
  const safeValue = value ?? "";

  return (
    <>
      {label && <label className={`form-label ${clsname}`}>{label}</label>}
      <input
        type={type}
        className={`form-control ${inpcls} ${error ? "is-invalid" : ""}`}
        value={safeValue}
        onChange={onChange}
        placeholder={placeholder}
        name={name}
        disabled={disabled}
        readOnly={readOnly}
      />
      {error && <div className="invalid-feedback">{error}</div>}
    </>
  );
};
export default InputField;
